import {faPlus, faXmark} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import {FormikState} from 'formik'
import React, {FC, Fragment, useEffect, useState} from 'react'
import { Button, OverlayTrigger } from 'react-bootstrap'
import CopyToClipboard from 'react-copy-to-clipboard'
import {
  MORE_MAPPING_FORM_DATA,
  MORE_TEMPLATE_DATA,
  MORE_TEMPLATE_DATA_ON_GET,
  MoreFieldMappingItem,
  MoreMapping_Item_On_Get,
  PLATFORM_FIELD_DATA,
} from 'src/interfaces/Template.interface'
import {getPlatformFieldsAsync} from 'src/redux/actions/productActions'
import {getPlatformParentFieldDataCategoriesAsync, getShortCodeAsync} from 'src/redux/actions/templateAndPricingActions'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import AppCustomEditor2 from 'src/utils/AppCustomEditor2'
import AddNewAttributeValueModal from '../../components/AddNewAttributeValueModal'
import CategoryAttributeForSelect from './CategoryAttributeForSelect.previous'
import MoreAttributeForSelect from './MoreAttributeForSelect.previous'
import { SectionHeaderLabel } from './SectionHeaderInfoTooltip.previous'
import Select from 'react-select';
import { isEmptyAttributeSelectValue } from '../utils/quicklistMoreMappingUtils.previous'

type OPTION_TYPE = 'NATIVE' | 'CUSTOM' | 'DEFAULT'
type LocationField = {
  input_type: string;
  name: string;
  href: string | null;
  display_name: string;
  is_required: boolean;
};
type TemplateMappingItemPropsType = {
  handleRemoveRow: (index: number, templateDataId:number|null) => void
  setFieldValue: (field: string, value: any) => void
  closeModal: () => void
  categoryAttributes: MoreFieldMappingItem
  index: number
  values: MORE_MAPPING_FORM_DATA
  handleChange: (e: string | React.ChangeEvent<any>) => void
  handleValueTextChange: (attributeId: number, value: string) => void
  selectedTextValues: {[key: number]: string | null}
  selectedFieldValues: {[key: number]: number}
  rowData: MORE_TEMPLATE_DATA
  setFormikState: (
    f:
      | FormikState<MORE_MAPPING_FORM_DATA>
      | ((prevState: FormikState<MORE_MAPPING_FORM_DATA>) => FormikState<MORE_MAPPING_FORM_DATA>),
    cb?: (() => void) | undefined
  ) => void
  moreTemplateItemData: MoreMapping_Item_On_Get | null
  moreTemplateItemDataUnderMap: MORE_TEMPLATE_DATA_ON_GET | null
  deletingTemplateData:boolean
  openAddNewAttributeValueModal: boolean
  setOpenAddNewAttributeValueModal: React.Dispatch<React.SetStateAction<boolean>>
  allowDataInsertion?: boolean
  insertionPayload?: LocationField[] | []
  fieldDataRefreshKey?: number
  nativeFields?: any[]
  customFields?: any[]
}

const TemplateMappingItem: FC<TemplateMappingItemPropsType> = ({
  closeModal,
   setFieldValue,
  handleRemoveRow,
  categoryAttributes,
  index,
  values,
  handleChange,
  handleValueTextChange,
  selectedTextValues,
  selectedFieldValues,
  rowData,
  setFormikState,
  moreTemplateItemData,
  moreTemplateItemDataUnderMap,
  deletingTemplateData,
  openAddNewAttributeValueModal,
  setOpenAddNewAttributeValueModal,
  allowDataInsertion,
  insertionPayload,
  fieldDataRefreshKey,
  nativeFields,
  customFields
}) => {
  const [attributeMappingOptions, setAttributeMappingOptions] = useState<OPTION_TYPE>('DEFAULT')

  const dispatch = useAppDispatch()
  const {mainStoreData, erpStoreData, omsStoreData, accountingStoreData, shippingStoreData, ticketStoreData, fetchedSourcePlatformData, fetchedConnectedPlatformData} = useAppSelector((state) => state.fetchConnectedPlatform) || {}
  const apiSource = fetchedSourcePlatformData?.source_platform
  const sourceStore = apiSource?.id
    ? apiSource
    : mainStoreData ?? omsStoreData ?? erpStoreData ?? accountingStoreData ?? shippingStoreData ?? null
  const sourceStoreId = sourceStore?.id

  const [fieldData, setFieldData] = useState<any[]>([])
  const [fieldDataCustom, setFieldDataCustom] = useState<any[]>([])
  const [dataSetLoading, setDataSetLoading] = useState<boolean>(false)
  const [platformFieldDataSet, setPlatformFieldDataSet] = useState<PLATFORM_FIELD_DATA[] | []>([])
  const [shortCode, setShortCode] = useState([])
  const [copyMarkup, setCopyMarkup] = useState<boolean>(false)
  const [buttonString, setButtonString] = useState('');
  const [shortCodeVisibility, setShortCodeVisibility] = useState(false);
  const [selectedValues, setSelectedValues] = useState<{[key: number]: number | null}>({})
  const handleCopyMarkup = (data: string, identifier: string) => {
      setCopyMarkup(true)
      setButtonString(data)
  };

  const handleShortCode = async (input: string) => {
    try {
      const response = await dispatch(
        getShortCodeAsync({ shortcode_type: 'PRODUCT_SC', search_string: input })
      );
      if (response.payload) {
        setShortCode(response.payload?.results);
        setShortCodeVisibility(true)
      }
    } catch (error) {
      console.error('Error fetching short codes:', error);
    }
  };

  const handleMappingOptionChange = (mappedIndex: number, option: any) => {
    setAttributeMappingOptions(option)

    if (option === 'NATIVE' || option === 'CUSTOM') {
      const fieldType = option === 'CUSTOM' ? 'CUSTOM' : 'NATIVE'
      
      // Use props if available
      if (nativeFields && customFields) {
        if (fieldType === 'NATIVE') {
          setFieldData(nativeFields)
        } else {
          setFieldDataCustom(customFields)
        }
      } else {
        setDataSetLoading(true)
        const sourceStore = apiSource?.id ? apiSource : mainStoreData ?? omsStoreData ?? erpStoreData ?? accountingStoreData ?? shippingStoreData ?? null
        if (!sourceStore?.id) {
          setDataSetLoading(false)
          return
        }
        dispatch(
          getPlatformFieldsAsync({
            platformId: sourceStore.id,
            otherParams: {field_type: fieldType, includeLocalFields: option === 'NATIVE', owner: 'PRODUCT'},
          })
        ).then((response) => {
          if (fieldType === 'NATIVE') {
            setFieldData(response.payload)
            setDataSetLoading(false)
          } else {
            setFieldDataCustom(response.payload)
            setDataSetLoading(false)
          }
        })
      }
    }

    // Reset the mutually exclusive fields when mapping type changes
    let templateDataMappingShadow = [...values.template_data]
    if (mappedIndex === 0) {
      if (option === 'DEFAULT') {
        setFieldValue('mapped_field', null)
        setFieldValue('value', null)
        setFieldValue('value_str', '')
        setFormikState((pre) => {
          const initialTemplateRow = pre.values.template_data?.[0]
          return {
            ...pre,
            values: {
              ...pre.values,
              mapped_field: null,
              value: null,
              value_str: '',
              template_data: [
                {
                  id: initialTemplateRow?.id ?? null,
                  mapped_field: null,
                  value: null,
                  value_str: '',
                },
              ],
            },
          }
        })
      } else {
        // Switching to a mapped field should drop any default value
        setFieldValue('value', null)
        setFieldValue('value_str', '')
        templateDataMappingShadow[mappedIndex] = {
          id: templateDataMappingShadow[mappedIndex].id,
          mapped_field: null,
          value: null,
          value_str: '',
        }
        setFormikState((pre) => {
          return {...pre, values: {...pre.values, template_data: templateDataMappingShadow}}
        })
      }
    } else {
      templateDataMappingShadow[mappedIndex] = {
        id: templateDataMappingShadow[mappedIndex].id,
        mapped_field: null,
        value: null,
        value_str: '',
      }
      setFormikState((pre) => {
        return {...pre, values: {...pre.values, template_data: templateDataMappingShadow}}
      })
    }
  }

  useEffect(() => {
    if (
      (categoryAttributes && categoryAttributes.input_type === 'MULTI_INSTANCE_SELECT') || (categoryAttributes && categoryAttributes.input_type === 'MULTISELECT') ||
      (categoryAttributes && categoryAttributes.input_type === 'SELECT')
    ) {
      setDataSetLoading(true)
      dispatch(
        getPlatformParentFieldDataCategoriesAsync({
          platform_Id: categoryAttributes.id!,
        })
      )
        .then((response) => {
          setPlatformFieldDataSet(response.payload)
          setDataSetLoading(false)
        })
        .catch(() => {
          setDataSetLoading(false)
        })
    }
  }, [categoryAttributes, fieldDataRefreshKey])

  //under mapping case fill the values with their field type

  useEffect(() => {
    if (moreTemplateItemDataUnderMap?.mapped_field && sourceStoreId) {
      if (
        moreTemplateItemDataUnderMap.mapped_field.field_type === 'LOCAL' ||
        moreTemplateItemDataUnderMap.mapped_field.field_type === 'NATIVE'
      ) {
        setAttributeMappingOptions('NATIVE')
        
        if (nativeFields) {
          setFieldData(nativeFields)
        } else {
          setDataSetLoading(true)
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStoreId,
              otherParams: {
                field_type: moreTemplateItemDataUnderMap.mapped_field.field_type,
                includeLocalFields: true,
                owner: 'PRODUCT',
              },
            })
          ).then((response) => {
            setFieldData(response.payload)
            setDataSetLoading(false)
          })
        }
      } else {
        setAttributeMappingOptions('CUSTOM')
        
        if (customFields) {
          setFieldDataCustom(customFields)
        } else {
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStoreId,
              otherParams: {field_type: moreTemplateItemDataUnderMap.mapped_field.field_type, owner: 'PRODUCT'},
            })
          ).then((response) => {
            setFieldDataCustom(response.payload)
          })
        }
      }
    }
  }, [moreTemplateItemDataUnderMap])

  useEffect(() => {
    if (moreTemplateItemData?.mapped_field && sourceStoreId) {
      if (
        moreTemplateItemData.mapped_field.field_type === 'LOCAL' ||
        moreTemplateItemData.mapped_field.field_type === 'NATIVE'
      ) {
        setDataSetLoading(true)
        setAttributeMappingOptions('NATIVE')
        dispatch(
          getPlatformFieldsAsync({
            platformId: sourceStoreId,
            otherParams: {
              field_type: moreTemplateItemData.mapped_field.field_type,
              includeLocalFields: true,
              owner: 'PRODUCT',
            },
          })
        ).then((response) => {
          setFieldData(response.payload)
          setDataSetLoading(false)
        })
      } else {
        setAttributeMappingOptions('CUSTOM')
        dispatch(
          getPlatformFieldsAsync({
            platformId: sourceStoreId,
            otherParams: {field_type: moreTemplateItemData.mapped_field.field_type, owner: 'PRODUCT'},
          })
        ).then((response) => {
          setFieldDataCustom(response.payload)
          setDataSetLoading(false)
        })
      }
    }
  }, [moreTemplateItemData?.mapped_field, moreTemplateItemData?.value])
  const handleValueChange = (attributeId: number, value: number | null) => {
    if (value === null || value === undefined) {
      setFieldValue('value', null)
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [attributeId]: null,
      }))
      return
    }

    setFieldValue('value', value)
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [attributeId]: value,
    }))
    // Call constructPayloadAttribute when attribute value changes
    // constructPayloadAttribute(mappingOptions, selectedTextValues, selectedValues, selectedFieldValues);
  }

  /** Placeholder option ("Select ITEM_ATTRIBUTES") must store null, not the label text. */
  const handleAttributeSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (isEmptyAttributeSelectValue(e.target.value)) {
      setFieldValue(e.target.name, null)
      if (e.target.name === 'value' || e.target.name.endsWith('.value')) {
        setFieldValue('value', null)
      }
      if (e.target.name === 'mapped_field' || e.target.name.endsWith('.mapped_field')) {
        setFieldValue('mapped_field', null)
      }
      return
    }
    handleChange(e)
  }

  const mappingFields = attributeMappingOptions === 'NATIVE' ? fieldData : fieldDataCustom
  const mappedFieldOptions = Array.isArray(mappingFields)
    ? [...mappingFields]
        .filter(Boolean)
        .sort((a, b) =>
          (a?.display_name ?? '').localeCompare(b?.display_name ?? '', undefined, {sensitivity: 'base'})
        )
        .map((field) => ({
          value: field.id,
          label: field.display_name ?? '',
        }))
    : []
  return (
    <div className={clsx('row w-100 mb-3',   ['MULTILINE_TEXT','MULTILINETEXT'].includes(categoryAttributes.input_type) ? '' : 'align-items-center'  )}>
      
      <div className='mb-3 row fs-6 form-label'>
           <div className='col-sm-3 col-6'>Attribute Name</div>
           <div className='col-sm-3 col-6'>Mapping Type</div>
           <div className='col-sm-6 col-12 ps-5'>Attribute Value</div>
           </div>
      <div className='col-sm-3 col-6'>
        <label className="form-label flex-shrink-0 mb-0">
          <SectionHeaderLabel
            title={categoryAttributes.display_name}
            tooltip={categoryAttributes.description || undefined}
            tooltipId={`more-mapping-attribute-${categoryAttributes.id}`}
          />
        </label>
      </div>

      <div className='col-sm-3 col-6'>
        <div className='row align-items-center'>
          <div className='p-0'>
            <select
              className='form-select flex-grow-1'
              style={{height:"39px"}}
              value={attributeMappingOptions}
              onChange={(e) => handleMappingOptionChange(index, e.target.value)}
            >
              <option value='DEFAULT'>Default</option>
              <option value='NATIVE'>Native Field</option>
              <option value='CUSTOM'>Custom Field</option>
            </select>
          </div>
        </div>
      </div>
      {index == 0 ? (
        <>
          <div className='col-12 col-sm-6 mt-2 mt-sm-0'>
            <div className='row p-0'>
              {attributeMappingOptions === 'DEFAULT' ? (
                <div className='col-10 col-sm-8 ms-sm-3  mb-0 ms-sm-0 me-sm-3 '>
                  {categoryAttributes.input_type === 'SELECT' && (
               <MoreAttributeForSelect
               platformid={categoryAttributes.id!}
                          attribute={categoryAttributes}
                          selectedValues={selectedValues}
                          val ={values}
                          handleValueChange={handleValueChange}
                        />
                  )}
                     
                  {categoryAttributes.input_type === 'TEXT' && (
                    <input
                      type='text'
                      name='value_str'
                      className='form-control flex-grow-1'
                      placeholder={categoryAttributes.display_name}
                      value={values?.value_str ? values?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                   {categoryAttributes.input_type === 'INTEGER' && (
                    <input
                      type='number'
                      name='value_str'
                      className='form-control flex-grow-1'
                      placeholder={categoryAttributes.display_name}
                      // value={values?.value ?  values?.value : 0}
                      value={values?.value_str!==null ? values?.value_str : ''}
                      onChange={handleChange}
                    />)}
                  {categoryAttributes.input_type === 'MULTI_INSTANCE_TEXT' && (
                    <input
                      type='text'
                      name={`template_data[${index}].value_str`}
                      className='form-control  flex-grow-1'
                      placeholder={categoryAttributes.display_name}
                      value={rowData?.value_str ? rowData?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                  {(categoryAttributes.input_type === 'MULTI_INSTANCE_SELECT' || categoryAttributes && categoryAttributes.input_type === 'MULTISELECT') && (
                    <select
                      className='form-select d-flex flex-wrap  flex-grow-1'
                      name={`template_data[${index}].value`}
                      disabled={dataSetLoading}
                      value={rowData?.value ? rowData?.value : ''}
                      onChange={handleAttributeSelectChange}
                    >
                      <option value="">Select {categoryAttributes.display_name}</option>
                      {platformFieldDataSet?.map((field: PLATFORM_FIELD_DATA) => (
                        <option key={field.id} value={field.id}>
                          {field.api_name}
                        </option>
                      ))}
                    </select>
                  )}

                  {categoryAttributes.input_type === 'MULTILINE_TEXT' && (
                        <>
                        <AppCustomEditor2 value={rowData.value_str} onChangeData={(val)=>{
                          let shadowTemplate = [...values.template_data]
                          shadowTemplate[index].value_str = val
                          setFormikState(pre=>{
                            return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                          })
                        }} />
                        <div>
                        <div className='text-end'>
                          <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                            <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                          </button>
                        </div>
                        <div className='text-end w-md-100'>
                        {shortCodeVisibility ? (
                          <div className='text-end'>
                            {shortCode
                              ? shortCode.map((item: any) => {
                                  return (
                                    <Fragment key={item.id}>
                                      <CopyToClipboard text={item.name}>
                                        <Button
                                          size='sm'
                                          variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                          className={`px-3 py-2 border border-1 m-2 ${
                                            copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                          } rounded text-hover-white fs-sm-8 inline-block`}
                                          onClick={() => handleCopyMarkup(item.name, 'description')}
                                        >
                                          {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                        </Button>
                                      </CopyToClipboard>
                                    </Fragment>
                                  );
                                })
                              : null}
                          </div>
                        ) : null}
                        </div>
                        </div>
                      </>
                  )}

                  {categoryAttributes.input_type === 'MULTILINETEXT' && (
                        <>
                        <AppCustomEditor2 value={rowData.value_str} onChangeData={(val)=>{
                          let shadowTemplate = [...values.template_data]
                          shadowTemplate[index].value_str = val
                          setFormikState(pre=>{
                            return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                          })
                        }} />
                        <div>
                        <div className='text-end'>
                          <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                            <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                          </button>
                        </div>
                        <div className='text-end w-md-100'>
                        {shortCodeVisibility ? (
                          <div className='text-end'>
                            {shortCode
                              ? shortCode.map((item: any) => {
                                  return (
                                    <Fragment key={item.id}>
                                      <CopyToClipboard text={item.name}>
                                        <Button
                                          size='sm'
                                          variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                          className={`px-3 py-2 border border-1 m-2 ${
                                            copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                          } rounded text-hover-white fs-sm-8 inline-block`}
                                          onClick={() => handleCopyMarkup(item.name, 'description')}
                                        >
                                          {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                        </Button>
                                      </CopyToClipboard>
                                    </Fragment>
                                  );
                                })
                              : null}
                          </div>
                        ) : null}
                        </div>
                        </div>
                      </>
                  )}
                  
                </div>
              ) : (
                <div className='col-10 col-sm-8  ms-sm-3 '>
                  {categoryAttributes.input_type.includes('MULTI') ? (
                    <select
                      className='form-select d-flex flex-wrap   me-2 flex-grow-1 '
                      name={`template_data[${index}].mapped_field`}
                      value={rowData?.mapped_field ? rowData?.mapped_field : ''}
                      onChange={handleAttributeSelectChange}
                      disabled={dataSetLoading}
                    >
                      <option value="">{dataSetLoading?'Loading...':`Select ${categoryAttributes.display_name}`}</option>
                      {attributeMappingOptions === 'NATIVE'
                        ? fieldData?.map((field) => (
                            <option key={field.id} value={field.id}>
                              {field.display_name}
                            </option>
                          ))
                        : fieldDataCustom?.map((field) => (
                            <option key={field.id} value={field.id}>
                              {field.display_name}
                            </option>
                          ))}
                    </select>
                    ) : (
                      <Select
                        id='mappedFieldSelect'
                        isDisabled={dataSetLoading}
                        placeholder={
                          dataSetLoading
                            ? 'Loading...'
                            : `Select ${categoryAttributes.display_name}`
                        }
                        // options list ΓÇö same data, sorted alphabetically
                        options={mappedFieldOptions}
                        //  Keep handleChange behavior identical to <select>
                        onChange={(selectedOption) => {
                          setFieldValue('mapped_field', selectedOption ? String(selectedOption.value) : '');
                        }}
                        classNamePrefix='react-select'
                        //  Selected value logic (fix for visibility)
                        value={mappedFieldOptions.find((opt) => String(opt.value) === String(values.mapped_field)) || null}
                        isSearchable //  Enables search
                        isClearable={true}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: '30px',
                            height: '30px',
                            borderColor: state.isFocused ? '#212529' : base.borderColor,
                            boxShadow: 'none',
                            '&:hover': { borderColor: '#212529' },
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: '#212529',
                            fontSize: '13px',
                          }),
                          indicatorSeparator: (base) => ({
                            ...base,
                            display: 'none', // removes vertical line
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            color: '#212529',
                            padding: '4px',
                            '& svg': {
                              width: '20px',
                              height: '18px',
                            },
                          }),
                          clearIndicator: (base) => ({
                            ...base,
                            padding: '4px',
                            color: '#212529',
                            '&:hover': { color: '#212529' },
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            height: '30px',
                            padding: '0 6px',
                          }),
                          input: (base) => ({
                            ...base,
                            margin: '0px',
                            padding: '0px',
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: '#212529',
                            fontSize: '13px',
                          }),
                        }}
                      />
                    )}
                </div>
              )}

              <div className='col-2'>
                {index !== 0 && (
                  <button
                    className='btn btn-outline btn-light-danger ms-4 mt-2 mb-4 text-end'
                    type='button'
                    disabled={deletingTemplateData}
                    onClick={() => handleRemoveRow(index, rowData.id)}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='col-12 col-sm-6 mt-1 mt-sm-0 '>
            <div className='row p-0 ms-sm-1'>
              {attributeMappingOptions === 'DEFAULT' ? (
                <div className='col-10 col-sm-8  ms-sm-0  mb-0 ms-sm-0 me-sm-0'>
                  {categoryAttributes.input_type === 'SELECT' && (
                    <select
                      className='form-select d-flex flex-wrap  flex-grow-1'
                      name='value'
                      disabled={dataSetLoading}
                      value={values?.value ? values?.value : ''}
                      onChange={handleAttributeSelectChange}
                    >
                      <option value="">Select {categoryAttributes.display_name}</option>
                      {platformFieldDataSet?.map((field: PLATFORM_FIELD_DATA) => (
                        <option key={field.id} value={field.id}>
                          {field.api_name}
                        </option>
                      ))}
                    </select>
                  )}
                  {categoryAttributes.input_type === 'TEXT' && (
                    <input
                      type='text'
                      name='value_str'
                      className='form-control flex-grow-1'
                      placeholder={categoryAttributes.display_name}
                      value={values?.value_str ? values?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                  {categoryAttributes.input_type === 'MULTI_INSTANCE_TEXT' && (
                    <input
                      type='text'
                      name={`template_data[${index}].value_str`}
                      className='form-control flex-grow-1'
                      placeholder={categoryAttributes.display_name}
                      value={rowData?.value_str ? rowData?.value_str : ''}
                      onChange={handleChange}
                    />
                  )}
                  {(categoryAttributes.input_type === 'MULTI_INSTANCE_SELECT' || categoryAttributes && categoryAttributes.input_type === 'MULTISELECT') && (
                    <select
                      className='form-select d-flex flex-wrap flex-grow-1'
                      name={`template_data[${index}].value`}
                      disabled={dataSetLoading}
                      value={rowData?.value ? rowData?.value : ''}
                      onChange={handleAttributeSelectChange}
                    >
                      <option value="">Select {categoryAttributes.display_name}</option>
                      {platformFieldDataSet?.map((field: PLATFORM_FIELD_DATA) => (
                        <option key={field.id} value={field.id}>
                          {field.api_name}
                        </option>
                      ))}
                    </select>
                  )}
                  {categoryAttributes.input_type === 'MULTILINE_TEXT' && (
                    <>
                      <AppCustomEditor2 value={rowData.value_str} onChangeData={(val)=>{
                        let shadowTemplate = [...values.template_data]
                        shadowTemplate[index].value_str = val
                        setFormikState(pre=>{
                          return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                        })
                      }} />
                      <div>
                      <div className='text-end'>
                        <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                          <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                        </button>
                      </div>
                      <div className='text-end w-md-100'>
                      {shortCodeVisibility ? (
                        <div className='text-end'>
                          {shortCode
                            ? shortCode.map((item: any) => {
                                return (
                                  <Fragment key={item.id}>
                                    <CopyToClipboard text={item.name}>
                                      <Button
                                        size='sm'
                                        variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                        className={`px-3 py-2 border border-1 m-2 ${
                                          copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                        } rounded text-hover-white fs-sm-8 inline-block`}
                                        onClick={() => handleCopyMarkup(item.name, 'description')}
                                      >
                                        {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                      </Button>
                                    </CopyToClipboard>
                                  </Fragment>
                                );
                              })
                            : null}
                        </div>
                      ) : null}
                      </div>
                      </div>
                    </>
                  )}
                  {categoryAttributes.input_type === 'MULTILINETEXT' && (
                    <>
                      <AppCustomEditor2 value={rowData.value_str} onChangeData={(val)=>{
                        let shadowTemplate = [...values.template_data]
                        shadowTemplate[index].value_str = val
                        setFormikState(pre=>{
                          return {...pre, values:{ ...pre.values , template_data: shadowTemplate }}
                        })
                      }} />
                      <div>
                      <div className='text-end'>
                        <button type='button' className='btn text-muted text-hover-primary fw-bold mt-1 cursor-pointer' onClick={() => handleShortCode('description')}>
                          <FontAwesomeIcon icon={faPlus} className='me-2' /> See the Options here
                        </button>
                      </div>
                      <div className='text-end w-md-100'>
                      {shortCodeVisibility ? (
                        <div className='text-end'>
                          {shortCode
                            ? shortCode.map((item: any) => {
                                return (
                                  <Fragment key={item.id}>
                                    <CopyToClipboard text={item.name}>
                                      <Button
                                        size='sm'
                                        variant={copyMarkup && buttonString === item.name ? 'outline-success' : 'outline-primary'}
                                        className={`px-3 py-2 border border-1 m-2 ${
                                          copyMarkup && buttonString === item.name ? 'border-success' : 'border-primary'
                                        } rounded text-hover-white fs-sm-8 inline-block`}
                                        onClick={() => handleCopyMarkup(item.name, 'description')}
                                      >
                                        {copyMarkup && buttonString === item.name ? <span className='fs-sm-8'>Copied !</span> : item.name}
                                      </Button>
                                    </CopyToClipboard>
                                  </Fragment>
                                );
                              })
                            : null}
                        </div>
                      ) : null}
                      </div>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className='col-10 col-sm-8  mb-0 '>
                  <select
                    className='form-select d-flex flex-wrap  me-4 flex-grow-1'
                    name={`template_data[${index}].mapped_field`}
                    value={rowData?.mapped_field ? rowData?.mapped_field : ''}
                    onChange={handleAttributeSelectChange}
                    disabled={dataSetLoading}
                  >
                    <option value="">{dataSetLoading?'Loading...':`Select ${categoryAttributes.display_name}`}</option>
                    {attributeMappingOptions === 'NATIVE'
                      ? fieldData?.map((field) => (
                          <option key={field.id} value={field.id}>
                            {field.display_name}
                          </option>
                        ))
                      : fieldDataCustom?.map((field) => (
                          <option key={field.id} value={field.id}>
                            {field.display_name}
                          </option>
                        ))}
                  </select>
                </div>
              )}

              <div className='col-2  '>
                {index !== 0 && (
                  <button
                    className='btn btn-outline btn-light-danger ms-4  text-end'
                    type='button'
                    disabled={deletingTemplateData}
                    onClick={() => handleRemoveRow(index, rowData.id)}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <AddNewAttributeValueModal
      closeModal = {closeModal}
        categoryAttributes={categoryAttributes}
        isVisible={openAddNewAttributeValueModal}
        allowDataInsertion={allowDataInsertion}
        insertionPayload={insertionPayload}
        setOpenAddNewAttributeValueModal={setOpenAddNewAttributeValueModal}
      />
    </div>
  )
}

export default TemplateMappingItem
